export default { sha: 'f00a2daf3d21ba994ab84581dd1df2ca707364e2', buildNumber: 'undefined' }
